import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Home from "../../views/Home.js";
import Auth from "../../views/Auth.js";

export default function Routes({ isAuth, updateUser }) {
  return (
    <Switch>
      {isAuth ? (
        <Route
          path="/"
          render={props => <Home {...props} updateUser={updateUser} />}
        />
      ) : (
        <Route path="/" render={props => <Auth {...props} />} />
      )}
      <Redirect to="/" />
    </Switch>
  );
}
